<template>
  <div>
    <p>Hello  {{name}}</p><br>
    <a href="" @click.prevent="goToTimeSheets()">Timesheets</a><br>
      <router-link to="/timesheets">Timesheets</router-link><br>
      <router-link to="/tapon">Start Timer</router-link><br>
  </div>
</template>

<script>

import envConfig from './env_config.js'
import axios from 'axios'
export default {
  name: 'Setup',
  props: {
  },
  data () {
    return {
      name:''
    }
  },
  methods: {
    goToTimeSheets() {
      
      this.$router.push('Timesheets') 
    }
  },
  mounted() {
    if (!localStorage.getItem('JWT')) {
      this.$router.push('Setup') 
      return;
    } else {
      this.name = localStorage.getItem('name')
    }
  },
  created: function () {
  }
}

</script>
<style>
</style>





